import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://admin.1oneplus.net/api';

export const registerUser = createAsyncThunk(
  'auth/registerUser',
  async ({ email, password, password_confirmation, name, phone, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/register`,
        { email, password, password_confirmation, name, phone },
        {
          headers: {
            'Accept': 'application/json',
            'Accept-Language': lang || 'en',
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.status === false) {
        return rejectWithValue(response?.data?.message || 'Registration failed');
      }

      // Store token in localStorage if returned (auto-login)
      if (response.data.data?.token) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        // Add for compatibility with other actions
        localStorage.setItem('userTools', JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        }));
      }

      return response.data;
    } catch (error) {
      const responseData = error.response?.data;
      const validationErrors = responseData?.errors || responseData?.error;
      const firstValidationMessage = validationErrors && typeof validationErrors === 'object'
        ? Object.values(validationErrors).flat()[0]
        : null;
      const message = firstValidationMessage
        || responseData?.message
        || responseData?.error
        || responseData?.data?.message
        || error.message
        || 'Registration failed';
      return rejectWithValue(message);
    }
  }
);
